import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CDFTService } from 'app/modules/cdft/services/cdft.service';
import { CDFTState } from 'app/modules/cdft/state/cdft.state';
import { Subscription } from 'rxjs';
import module from 'app/modules/cdft/cdft.module';

@Component({
  selector: 'app-annulus-pressure-table',
  templateUrl: './annulus-pressure-table.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: module,
  styleUrls: ['./annulus-pressure-table.component.scss']
})

export class AnnulusPressureTableComponent {
  @Input() isViewOnly: boolean;
  formGroup: FormGroup;
  private subscriptions: Subscription = new Subscription();

  constructor(
      private formBuilder: FormBuilder,
      private state: CDFTState,
      public service: CDFTService
  ){}

  

  get cdftAnnulusPressureReportDetails() {
    return this.formGroup.get('cdftAnnulusPressureReportDetails') as FormArray;
}

  ngOnInit() {
      this.formGroup = this.onFormGroup();
      this.state.setFormGroup("cdftAnnulusPressureReport", this.formGroup)
      this.onPopulate();
  }

  ngOnDestroy() {
      this.subscriptions.unsubscribe();
  }

  onPopulate() {
      const subscription = this.state.subscribe((cdft: CDFTState) => {
          if (!cdft.cdftAnnulusPressureReport) return;

          this.formGroup.patchValue(cdft.cdftAnnulusPressureReport);
      });

      this.subscriptions.add(subscription);
  }

  onFormGroup() {
    return this.formBuilder.group({
      id: new FormControl({ value: null, disabled: true }),
      cdftRecordId: new FormControl({ value: null, disabled: true }),
      result: new FormControl({ value: null, disabled: this.isViewOnly }),
      pcp: new FormControl({ value: false, disabled: false }),
      icp: new FormControl({ value: false, disabled: false }),
      scp: new FormControl({ value: false, disabled: false }),
      ccp: new FormControl({ value: false, disabled: false }),
      remarks: new FormControl({ value: null, disabled: this.isViewOnly }),
      cdftAnnulusPressureReportDetails: this.formBuilder.array(
          new Array(7).fill(0).map((element, index) => {
              const time = 5 * index;
              return this.formBuilder.group({
                  id: new FormControl({ value: null, disabled: true }),
                  cdftAnnulusPressureReportId: new FormControl({
                      value: null,
                  }),
                  time: new FormControl({ value: time, disabled: true }),
                  pcpAAnnulusPsi: new FormControl({
                      value: null,
                      disabled: this.isViewOnly,
                  }),
                  icpBAnnulusPsi: new FormControl({
                      value: null,
                      disabled: this.isViewOnly,
                  }),
                  scpCAnnulusPsi: new FormControl({
                      value: null,
                      disabled: this.isViewOnly,
                  }),
                  ccpDAnnulusPsi: new FormControl({
                      value: null,
                      disabled: this.isViewOnly,
                  }),
                  thpPsi: new FormControl({ value: null, disabled: this.isViewOnly }),
              });
          })
      ),
  });
  }
}
